import { css } from "@emotion/react";
import { CSS_MQ } from "../../../styles/breakpoints";

export const PDPDetailsWrapper: React.FC<{ children: React.ReactNode; Element: React.ReactNode }> = ({
  children,
  Element,
}) => {
  return (
    <div
      className="u-flex u-flex-col u-jc-between"
      css={css`
        ${CSS_MQ.atMostSm} {
          margin-bottom: 20px;
        }
      `}
    >
      <div
        css={css`
          ${CSS_MQ.atLeastMd} {
            > :last-child {
              margin-bottom: 0;
            }
            margin-bottom: 40px;
          }
        `}
      >
        {children}
      </div>

      {Element}
    </div>
  );
};
